import { render, staticRenderFns } from "./CMobile.vue?vue&type=template&id=2ee663f3&scoped=true&"
import script from "./CMobile.vue?vue&type=script&lang=js&"
export * from "./CMobile.vue?vue&type=script&lang=js&"
import style0 from "./CMobile.vue?vue&type=style&index=0&id=2ee663f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee663f3",
  null
  
)

export default component.exports